import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import Table from '../../../../../design-system/components/Table/Table';

const errorColumns = [
    { name: 'row_number', label: '#', minWidth: 40, align: 'center' },
    { name: 'correo', label: 'Correo', minWidth: 150, align: 'center' },
    { name: 'error', label: 'Error', minWidth: 250, align: 'center' },
];

const BulkResultSummary = ({ validCount, invalidCount, invalidRows, onDownloadErrors }) => {
    // Map the validation result shape { row, message } to what the table expects.
    const tableRows = (invalidRows || []).map((r, i) => ({
        id: r.row || i,
        row_number: r.row,
        correo: r.correo || '',
        error: r.message || '',
    }));

    return (
        <Box mt={2}>
            <Box display="flex" mb={2} style={{ gap: 16 }}>
                <Typography variant="body1" style={{ color: '#4caf50' }}>
                    ✅ {validCount} válido(s)
                </Typography>
                {invalidCount > 0 && (
                    <Typography variant="body1" style={{ color: '#f44336' }}>
                        ❌ {invalidCount} con errores
                    </Typography>
                )}
            </Box>
            {invalidCount > 0 && tableRows.length > 0 && (
                <Box>
                    <Box style={{ overflowX: 'auto', width: '100%' }}>
                        <Table
                            checkboxs={false}
                            maxHeight="300px"
                            columns={errorColumns}
                            rows={tableRows}
                        />
                    </Box>
                    <Box mt={1}>
                        <Button size="small" variant="contained" color="primary" onClick={onDownloadErrors}>
                            📥 Descargar errores Excel
                        </Button>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default BulkResultSummary;
